import { Link } from "react-router-dom";

const entries = [
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "新闻资讯",
    desc: "官方公告、影视动态与活动现场，第一时间掌握最新消息。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20scene%20with%20folded%20newspapers%20and%20soft%20golden%20light%2C%20minimal%20artistic%20photography%2C%20orange%20and%20cream%20palette%2C%20high%20detail%2C%20clean%20composition&width=640&height=480&seq=entry-news&orientation=landscape",
  },
  {
    to: "/works",
    icon: "ri-film-line",
    title: "作品介绍",
    desc: "电影、电视剧、音乐与纪录片，完整作品档案一览。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20cinema%20set%20with%20warm%20spotlight%20and%20soft%20film%20reel%2C%20minimal%20artistic%20photography%2C%20orange%20and%20charcoal%20palette%2C%20cinematic%20atmosphere%2C%20high%20detail&width=640&height=480&seq=entry-works&orientation=landscape",
  },
  {
    to: "/fans",
    icon: "ri-chat-heart-line",
    title: "粉丝交流",
    desc: "参与话题讨论、应援活动与云观影，与同好一起分享。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20community%20gathering%20scene%20with%20soft%20string%20lights%20and%20abstract%20bokeh%2C%20minimal%20artistic%20photography%2C%20amber%20and%20cream%20palette%2C%20cozy%20atmosphere%2C%20high%20detail&width=640&height=480&seq=entry-fans&orientation=landscape",
  },
];

export default function QuickLinks() {
  return (
    <section className="mx-auto w-full max-w-[1320px] px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative w-full overflow-hidden" style={{ height: 168 }}>
              <img
                src={entry.image}
                alt={`${entry.title}入口图`}
                title={`${entry.title} - 风间由美官方网站`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 to-transparent" />
              <span className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-background-50/90 text-primary-600 backdrop-blur">
                <i className={`${entry.icon} text-xl`} />
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {entry.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}